jQuery(document).ready(function ($) {

    $('.login-modal').on('submit', function (e) {
        let errors = [];
        
        // Check reCAPTCHA first before showing loader
        if (!window.validateFormRecaptcha(this)) {
            e.preventDefault();
            return false;
        }
        
        // Only show loader if reCAPTCHA validation passes
        $('.login-loader').show();
        $('.login-overlay').show();
        
        if ($(this).find('input#username_login').val().length === 0) {
            errors.push('Brukernavnet er obligatorisk');
        }

        if ($(this).find('input#password_login').val().length === 0) {
            errors.push('Passord er obligatorisk.');
        }

        if (errors.length > 0) {
            
            let errorsDiv = $(this).find('.errors');
            errorsDiv.html('');
            errors.map(item => {
                errorsDiv.append('<p>' + item + '</p>');
            });
            $('.login-overlay').hide();
            $('.login-loader').hide();
            e.preventDefault();
            
            //return false;
        }
        
        //return true;
    });

    $('.register-modal').on('submit', function (e) {
        let errors = [];
        
        // Check reCAPTCHA first before showing loader
        if (!window.validateFormRecaptcha(this)) {
            e.preventDefault();
            return false;
        }
        
        // Only show loader if reCAPTCHA validation passes
        $('.login-loader').show();
        $('.login-overlay').show();
        
        if ($(this).find('input#email').val().length === 0) {
            errors.push('Email is required.');
        }

        if ($(this).find('input#password').val().length === 0) {
            errors.push('Passord er obligatorisk.');
        }

        if ($(this).find('input#password_confirm').val().length === 0) {
            errors.push('Passordet må bekreftes.');
        }

        if ($(this).find('input#password').val() !== $(this).find('input#password_confirm').val()) {
            errors.push("Valgte passord samstemmer ikke.");
        }

        if ($(this).find('input#username').val().length === 0) {
            errors.push('Brukernavnet er obligatorisk');
        }

        if ($(this).find('input#first_name').val().length === 0) {
            errors.push('Fornavn er obligatorisk.');
        }

        if ($(this).find('input#last_name').val().length === 0) {
            errors.push('Etternavn er obligatorisk.');
        }
        
        if ($(this).find('input#legal_age').is(':checked')) {
            errors.push('Du må bekrefte at du er over 18 år gammel.');
        }
        
        if (errors.length > 0) {
            let errorsDiv = $(this).find('.errors');
            errorsDiv.html('');
            $('.login-overlay').hide();
            $('.login-loader').hide();
            errors.map(item => {
                errorsDiv.append('<p>' + item + '</p>');
            });
            e.preventDefault();
            return false;
        }

        return true;
    });

    $(".forgot-password-modal").on("submit", function(e) {
        e.preventDefault();
        let errors = [];
        let body = $('body');
        $('.login-loader').show();
        $('.login-overlay').show();

        const formData = new FormData();

        const url = $("input#lostpassword_url").val();
        const userEmail = $("input#forgot_password_email").val();

        if (userEmail.length === 0) {
            errors.push('Email is required.');
            showErrors(errors,"errors");
            return false;
        }

        formData.append("user_login", userEmail);
        formData.append("redirect_to", "");
        formData.append("wp-submit", "Get New Password")

        let data = {
            "action":"user_exists",
            "data":{
                email : userEmail
            }
        }
    
        $.ajax({
            type: "POST",
            url:script_object.ajax_url,
            data,
            dataType:"json",
            success:function(response) {
                if(!JSON.parse(response)) {
                    errors.push("Det er ingen konto med det brukernavnet eller e -postadressen");
                    showErrors(errors, "errors");
                    return false;
                }
                $.ajax({
                    url,
                    data: formData,
                    processData: false,
                    contentType: false,
                    type: 'POST',
                    success: function(data){
                        errors.push("En e -post ble sendt med ytterligere instruksjoner")
                        showErrors(errors, "success")
                        setTimeout(() => {
                            $(".login-register-modal").removeClass('show-forgot-password')
                            $(".login-register-modal").addClass('d-none')
                            body.removeClass('modal-active ');
                            $('#forgot_password_email').val('');
                            $(".forgot-password-modal").find(`.success`).html('');
                        }, 2000);
                    }
                });
            },
            error:function(err) {
            },
        })
    })

    function showErrors(errors, type) {
        $(".forgot-password-modal").find(`.errors`).html('');
        $(".forgot-password-modal").find(`.success`).html('');
        if (errors.length > 0) {
            let errorsDiv = $(".forgot-password-modal").find(`.${type}`);
            errorsDiv.html('');
            $('.login-overlay').hide();
            $('.login-loader').hide();
            errors.map(item => {
                errorsDiv.append('<p>' + item + '</p>');
            });
            return false;
        }
    }
});